export default __webpack_public_path__ + "static/media/QYON-Sistemas-Inteligentes_Black.12d79217.png";